import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { IMG, altFor } from "@/data/site";

export const ServiceCard = ({ s, index }) => {
  const Icon = s.icon;
  return (
    <Link
      to={`/services/${s.slug}`}
      data-testid={`service-card-${index}`}
      className="group relative flex h-full flex-col justify-between rounded-xl border border-ink/10 bg-white p-6 md:p-7 transition-[transform,background-color,border-color,box-shadow] duration-500 hover:-translate-y-1 hover:border-ink hover:bg-ink hover:shadow-[0_30px_60px_-30px_rgba(36,37,34,0.6)]"
    >
      <div>
        <div className="flex items-start justify-between">
          <span className="grid h-12 w-12 place-items-center rounded-lg bg-sand text-ink transition-colors duration-500 group-hover:bg-lime">
            <Icon className="h-5 w-5" strokeWidth={1.6} aria-hidden />
          </span>
          <span className="font-display text-sm font-semibold text-ink/40 group-hover:text-white/50">{String(index + 1).padStart(2, "0")}</span>
        </div>
        <h3 className="mt-8 text-xl font-semibold leading-snug text-ink group-hover:text-white">{s.name}</h3>
        <p className="mt-3 text-sm leading-relaxed text-ink/70 group-hover:text-white/75">{s.d}</p>
      </div>
      <span className="mt-8 inline-flex items-center gap-1.5 text-sm font-bold text-ink group-hover:text-lime">
        Learn more <ArrowUpRight className="h-4 w-4 transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden />
      </span>
    </Link>
  );
};

export const IndustryCard = ({ item, index, eager = false }) => (
  <Link
    to={`/industries/${item.slug}`}
    data-testid={`industry-card-${index}`}
    className="group relative block aspect-[4/5] overflow-hidden rounded-xl bg-ink"
  >
    <img
      src={IMG(item.image)}
      alt={altFor(item.image)}
      loading={eager ? "eager" : "lazy"}
      width="500"
      height="625"
      className="absolute inset-0 h-full w-full object-cover opacity-80 transition-[transform,opacity] duration-[1200ms] ease-out group-hover:scale-110 group-hover:opacity-60"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent" aria-hidden />
    <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
      <span className="mb-3 block h-0.5 w-6 bg-lime transition-[width] duration-500 group-hover:w-12" aria-hidden />
      <h3 className="font-display text-base md:text-lg font-semibold leading-tight text-white">{item.name}</h3>
    </div>
    <ArrowUpRight className="absolute right-4 top-4 h-5 w-5 text-white opacity-0 transition-opacity duration-500 group-hover:opacity-100" aria-hidden />
  </Link>
);
